<div class="main-content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <h4>View Assignment Upload
                </h4>
            </div>
            <div id="collapse-example" class="collapse show" aria-labelledby="heading-example">
            <div class="card-body">
                <form [formGroup]="ViewUploadForm" (ngSubmit)="SearchDetailsForMailStatus()">

                    <div class="cardSearch2">

                         <div class="card-header2 form-control2" data-toggle="collapse" href="#collapseFilers" (click)="showhide()" role="button"
                        
                         aria-expanded="false" aria-controls="collapseFilers">
                       
                        <header class="panel-heading">
                            <h5 class="panel-title">Search Filters(Tap to Expand)</h5>
                        </header>
                  
                        </div>
                        <div *ngIf="Ispanelshow" id="collapseFilers">
                            <div class="card-body2">
                               
                                <div class="row">
                                    <div class="form-group2 col-md-6">
                                        <label>Upload Date From</label>
                                        <div class="input-group ">
                                            <input readonly [matDatepicker]="FromDatePicker" formControlName="FromDate"
                                                class="form-control" placeholder="From Date"
                                                ng-model-options="{timezone: 'UTC'}" #ref
                                                (dateChange)="orgValueChange(ref.value)">
                                            <mat-datepicker-toggle class="input-group-addon iconWithInput" matSuffix
                                                [for]="FromDatePicker"></mat-datepicker-toggle>
                                            <mat-datepicker touchUi="true" #FromDatePicker></mat-datepicker>
                                        </div>
                                        
                                    </div>
                                    <div class="form-group col-md-6">
                                        <label>Upload Date To</label>
                                        <div class="input-group ">
                                            <input readonly [matDatepicker]="ToDatePicker" formControlName="ToDate"
                                                class="form-control" placeholder="To Date"
                                                ng-model-options="{timezone:'UTC'}">
                                            <mat-datepicker-toggle class="input-group-addon iconWithInput" matSuffix
                                                [for]="ToDatePicker"></mat-datepicker-toggle>
                                            <mat-datepicker touchUi="true" #ToDatePicker></mat-datepicker>
                                        </div>
                                    </div>
    
                                </div>
                              
                                <div class="row">
                                   <div class="col-md-12" style="text-align: center;margin-top: 20px;">
                                      
    
                                            <button class="btn-primary1" type="submit">
                                                Search</button>
    
                                            <button class="btn-primary1" type="button"
                                                (click)="reset()">Reset</button>

                                            <button class="btn-primary1" type="button"
                                                (click)="ExportToExcel()">Export</button>

                                                <button class="btn-primary1" type="button" (click)="onExit()">Exit</button>
                                </div>
                            </div>
    
                        </div>


                    </div>
                    </div>
                     

                    <div class="row">
                  
                        <div class="col-md-12">
                         
                          <div class="mat-elevation-z8 top-margin-border" #TABLE>
                  <table mat-table [dataSource]="ViewUploadDatasource" style="width:100% !important">
          
                    <ng-container matColumnDef="AssignmentGroupName">
                        <th mat-header-cell *matHeaderCellDef> Assignment Group </th>
                        <td mat-cell  *matCellDef="let element"> {{element.AssignmentGroupName}} </td>
                    </ng-container>

                    <ng-container matColumnDef="EmpName">
                        <th mat-header-cell *matHeaderCellDef> Uploaded By </th>
                        <td mat-cell *matCellDef="let element"> {{element.EmpName}} </td>
                    </ng-container>

                    <ng-container matColumnDef="UploadDate">
                        <th mat-header-cell *matHeaderCellDef> Upload Date </th>
                        <td mat-cell *matCellDef="let element"> {{element.UploadDate | date:'dd/MMM/yyyy'}}</td>
                    </ng-container>
                                
          
                      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                  </table>
                  <mat-paginator  #paginator
                  [length]="_global.length"
                  [pageIndex]="_global.pageIndex"
                  [pageSize]="_global.RecordSize"
                  [pageSizeOptions]="[5, 10, 25, 100]"
                  (page)="onPaginateChange1($event)"></mat-paginator>
                </div>
                      </div>
                     
                      
                        </div>

                </form>
            </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</div>